// src/AppBar.js - Updated version - Organization chip removed
import * as React from 'react';
import { AppBar, UserMenu, Logout, usePermissions } from 'react-admin';
import { Typography, Box, Tooltip, MenuItem, ListItemIcon, Chip, Divider, useMediaQuery, useTheme } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LockIcon from '@mui/icons-material/Lock';
import TeamSelector from './components/TeamSelector';

const CustomUserMenu = (props) => {
    const userRole = localStorage.getItem('userRole');
    const teamId = localStorage.getItem('userTeamId');

    return (
        <UserMenu {...props} icon={<AccountCircleIcon />}>
            <MenuItem disabled>
                <ListItemIcon>
                    <AccountCircleIcon />
                </ListItemIcon>
                <Box>
                    <Typography variant="body1">Role: {userRole || 'Unknown'}</Typography>
                    <Typography variant="body2">Team: {teamId || 'None selected'}</Typography>
                </Box>
            </MenuItem>
            
            <Divider />
            
            <MenuItem 
                component="a"
                href="#/change-password"
            >
                <ListItemIcon>
                    <LockIcon />
                </ListItemIcon>
                <Typography>Change password</Typography>
            </MenuItem>
            
            <Logout />
        </UserMenu>
    );
};

const MyAppBar = (props) => {
    const { permissions } = usePermissions();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    
    return (
        <AppBar
            {...props}
            userMenu={<CustomUserMenu />}
            color="primary"
        >
            {permissions === 'tenant_admin' && <TeamSelector />}

            <Box flex={1} />

            {!isSmallScreen && (
                <Tooltip title={`You are logged in as ${permissions}`}>
                    <Chip
                        label={permissions === 'tenant_admin' ? (isMediumScreen ? 'Tenant Admin' : 'Tenant Admin') : 'Team Admin'}
                        color={permissions === 'tenant_admin' ? 'secondary' : 'default'}
                        size="small"
                        sx={{ mr: 2 }}
                    />
                </Tooltip>
            )}
        </AppBar>
    );
};

export default MyAppBar;